'use client'
import type { FC, ReactNode } from 'react'
import NextLink, { type LinkProps } from 'next/link'

interface Props extends LinkProps {
  children: ReactNode
  className?: string
  rel?: 'alternate' | 'author' | 'bookmark' | 'help' | 'license' | 'me' | 'next' | 'prev' | 'search' | 'tag'
  role?: 'button' | 'link' | 'menuitem' | 'menuitemcheckbox' | 'menuitemradio' | 'option' | 'tab'
}

export const Link: FC<Props> = ({ href, children, rel, className, role, ...props }) => {
  return (
    <NextLink href={href} {...rel && { rel }} {...className && { className }} {...role && { role }} {...props}>
      {children}
    </NextLink>
  )
}
